module.exports = __webpack_public_path__ + "static/media/ann-flores-avatar@2x.6d7bfec0.png";